export default __webpack_public_path__ + "static/L1A_logo2-26ba95ef9dbf986de64741f096ee9d9a.png";